import { render, staticRenderFns } from "./DeviceShowcase.vue?vue&type=template&id=6be7d8fc&scoped=true"
import script from "./DeviceShowcase.vue?vue&type=script&lang=js"
export * from "./DeviceShowcase.vue?vue&type=script&lang=js"
import style0 from "./DeviceShowcase.vue?vue&type=style&index=0&id=6be7d8fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6be7d8fc",
  null
  
)

export default component.exports